import { FunctionComponent } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { TextField } from '@mui/material';
import { CreateTransactionModalFormModel } from '../CreateTransactionModal/CreateTransactionModalFormModel';
import { useTranslation } from '@/lib';

interface TransactionNotesFieldProps {
  control: Control<CreateTransactionModalFormModel>;
  errors: FieldErrors<CreateTransactionModalFormModel>;
  disabled?: boolean;
}

export const TransactionNotesField: FunctionComponent<TransactionNotesFieldProps> = ({ control, errors, disabled }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="notes"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label={t('notes')}
          multiline
          minRows={1}
          maxRows={4}
          error={errors.notes !== undefined}
          helperText={errors.notes?.message}
          disabled={disabled}
        />
      )}
    />
  );
};
